function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "87B8CC4A-BD51-4602-9899-3288CAB26AAC");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "mobile-design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu",
  transform: "translate(-57.000000, -528.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(41.000000, 518.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "call-support-01",
  transform: "translate(16.134454, 11.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.05042017,8.72727273 C7.18557543,10.477183 8.68611036,11.9652135 10.4507257,13.0909091 C11.1651525,13.518734 12.0807953,13.414107 12.6783804,12.8363636 L13.8334607,11.6909091 C14.0940555,11.4364191 14.4766745,11.348588 14.8235294,11.4636364 C15.6818359,11.7436034 16.5716551,11.9176416 17.4728801,11.9818182 C18.4763565,12.0622536 19.2498384,12.8925506 19.2513369,13.8909091 L19.2513369,15.6363636 C19.3338052,16.3042689 19.1135788,16.9740783 18.649963,17.4654167 C18.1863472,17.956755 17.5270089,18.2191052 16.8495034,18.1818182 C8.42574066,17.341993 1.76361284,10.7353829 0.916730328,2.38181818 C0.857102755,1.77029426 1.06133599,1.16232223 1.47886492,0.708426933 C1.89639386,0.254531638 2.4881836,-0.0028521388 3.10771581,1.39282473e-14 L5.25286478,1.39282473e-14 C6.26134397,-0.00290662694 7.1011659,0.766463571 7.17799847,1.76363636 C7.24271434,2.65735109 7.41821501,3.53975513 7.70053476,4.39090909 C7.82446559,4.73323979 7.73070784,5.11587358 7.46218487,5.36363636 L6.29793736,6.51818182 C5.71832197,7.11298829 5.61660621,8.02080136 6.05042017,8.72727273 Z",
  id: "Path"
})))));

var SvgCallSupport = function SvgCallSupport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCallSupport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call-support.c62f62de.svg";
export { ForwardRef as ReactComponent };